// import { useLocation } from 'react-router-dom';
import { useUpdate_Block_List_Item_By_PkMutation } from '@geerd-nx/shareable-graphql';
export function useEditBlockListItem() {
  // function useQueryParams() {
  //   return new URLSearchParams(useLocation().search);
  // }
  // const query = useQueryParams();
  // const pageIndex = parseInt(query.get("page") ?? "") || 0;
  // const pageSize = parseInt(query.get("pageSize") ?? "") || 10;

  const [mutate] = useUpdate_Block_List_Item_By_PkMutation();
  // {
  // update: ({ data }, cache) => {
  //   const prevData = cache.readQuery<
  //     Query_Root,
  //     Query_RootBlock_List_ItemArgs
  //   >({
  //     query: BLOCK_LIST_GET_MANY,
  //     variables: {
  //       order_by: [{ created_at: Order_By.Desc }],
  //       limit: pageSize,
  //       offset: pageIndex * pageSize,
  //     },
  //   });
  //   const newData = {
  //     block_list_item: [
  //       ...(prevData?.block_list_item.map((el) => {
  //         if (el.id === data?.update_block_list_item_by_pk?.id) {
  //           return data?.update_block_list_item_by_pk;
  //         }
  //         return el;
  //       }) ?? []),
  //     ],
  //   };
  //   cache.writeQuery({
  //     query: BLOCK_LIST_GET_MANY,
  //     data: newData,
  //   });
  // },
  // }
  return mutate;
}
